import { UIView } from "@uirouter/react";

export const AdIntelligenceRoot = () => {
    return (
        <div className="sw-layout-module sw-layout-no-scroll-container fadeIn">
            <UIView />
        </div>
    );
};
